// ── Shared state for all modules ──
// Variables exported as `let` provide live bindings — importers always see current value.
// For variables that need reassignment from outside this module, use the set* functions.

// ── Board data ──
export let boardData = null;
export function setBoardData(v) { boardData = v; }

// ── Navigation state ──
export let navStack = [];
export function setNavStack(v) { navStack = v; }

// ── Expanded card state (persists across re-renders) ──
export let expandedCards = new Set();

// ── Pending focus/rename state ──
export let _pendingTaskFocusId = null;
export function setPendingTaskFocusId(v) { _pendingTaskFocusId = v; }
export let _pendingCardRenameId = null;
export function setPendingCardRenameId(v) { _pendingCardRenameId = v; }

// ── Optimistic concurrency version for overrides ──
export let _localOverridesVersion = 0;
export function setLocalOverridesVersion(v) { _localOverridesVersion = v; }

// ── Card flags cache (ephemeral — NOT stored in overrides) ──
export let _cardFlagsCache = {};
export function setCardFlagsCache(v) { _cardFlagsCache = v; }
export let _cardFlagsTimer = null;
export function setCardFlagsTimer(v) { _cardFlagsTimer = v; }
export let _dismissedFlagsCache = {};
export function setDismissedFlagsCache(v) { _dismissedFlagsCache = v; }

// ── AI name — fetched from API, used everywhere in UI ──
export let AI_NAME = 'Cap';
export function setAiName(v) { AI_NAME = v; }

// ── Suggestion cache (ephemeral) ──
export let _suggestionCache = {};
export let _activeSuggestPollCardId = null;
export function setActiveSuggestPollCardId(v) { _activeSuggestPollCardId = v; }
export let _activeSuggestPollTimer = null;
export function setActiveSuggestPollTimer(v) { _activeSuggestPollTimer = v; }
export let _activeSuggestPollTimeout = null;
export function setActiveSuggestPollTimeout(v) { _activeSuggestPollTimeout = v; }

// ── Focus trap utility state ──
export let _activeFocusTrap = null;
export function setActiveFocusTrap(v) { _activeFocusTrap = v; }
export let _focusTrapTrigger = null;
export function setFocusTrapTrigger(v) { _focusTrapTrigger = v; }

// ── Shared ref objects for module dependency injection ──
export const _boardDataRef = { get value() { return boardData; }, set value(v) { boardData = v; } };
export const _activeFocusTrapRef = { get value() { return _activeFocusTrap; }, set value(v) { _activeFocusTrap = v; } };
export const _focusTrapTriggerRef = { get value() { return _focusTrapTrigger; }, set value(v) { _focusTrapTrigger = v; } };

// ── Comms cache (lazy-loaded external comms) ──
export const _commsCache = {};
export async function fetchComms(cardId) {
  // Stub — comms externalisation not yet implemented
  return null;
}
